import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { MaxBrainLocation } from './location.model';

export class LocationStateModel extends EntityStateModel<MaxBrainLocation> {}
